(function($){
    'use strict';

    var allevents        = "/_design/Nesters/event-detail/all-events",
        alleventsgrouped = "/_design/Nesters/event-detail/all-events-gby-category";
    //prev&next event
    if ($("h1").attr('data-eventid')) {
        var eventid  = $("h1").attr('data-eventid');

        var $prevContainer = $('.page-navigation__item.navigation__prev'),
            $nextContainer = $('.page-navigation__item.navigation__next');

        if(eventid) {
            $.ajax({
                method: 'GET',
                //url: 'http://newliverpool.clients.squiz.net/_design/Nesters/event-detail/all-events?version=1.1' //local
                url: allevents //live
            }).done(function(data){
                if(!isDataEmpty(data)) {
                    var currEventIndex = 0;

                    for (var index in data) {
                        var item = data[index];

                        if(item.id == eventid) {
                            currEventIndex = index;
                            break;
                        }
                    }

                    currEventIndex = parseInt(currEventIndex);
                    var prevEventIndex = currEventIndex - 1,
                        nextEventIndex = currEventIndex + 1;

                    if(prevEventIndex >= 0) {
                        var prevEvent = data[prevEventIndex];
                        navEvent(prevEvent, 'prev');
                    }

                    if(nextEventIndex < data.length) {
                        var nextEvent = data[nextEventIndex];
                        navEvent(nextEvent, 'next');
                    }
                }
            }).fail(function(error){
            //do sth
            }).always(function(){

            });
        }
    }

    //similar event
    if ($("h1").attr('data-eventid') && $("h1").attr('data-category')) {
        var eventid  = $("h1").attr('data-eventid'),
            category = $("h1").attr('data-category');
        if(eventid && category) {
            $.ajax({
                method: 'GET',
                //url: 'http://newliverpool.clients.squiz.net/_design/Nesters/event-detail/all-events-gby-category' //local
                url: alleventsgrouped //live
            }).done(function(data){
                if(!isDataEmpty(data)) {
                    if (data.hasOwnProperty(category)) {
                        var similarEvents = data[category];

                        var currEventIndex = 0;

                        if(similarEvents.length > 1) {
                            for (var index in similarEvents) {
                                var event = similarEvents[index];
                                if(event.id == eventid) {
                                    currEventIndex = parseInt(index);
                                    break;
                                }
                            }

                            var upcomingEventIndex = currEventIndex + 1;
                            var upcomingEvent      = '';
                            while(upcomingEventIndex <  similarEvents.length) {
                                upcomingEvent = similarEvents[upcomingEventIndex];

                                var dateObj = new Date(upcomingEvent.date);
                                var today   = new Date();
                                if(dateObj < today) {
                                    upcomingEventIndex++;
                                    continue;
                                } else {
                                    break;
                                }
                            }

                            if(upcomingEvent != '') {
                                similarEvent(upcomingEvent);
                            }
                        }
                    }
                }
            }).fail(function(error){
            //do sth
            }).always(function(){

            });
        }
    }

    function isDataEmpty(dataObj) {
        for(var prop in dataObj) {
            if(dataObj.hasOwnProperty(prop))
                return false;
        }

        return true;
    }

    function similarEvent(event) {
        var title     = event.name,
            eventdate = event.event_date,
            eventtime = event.event_time,
            location  = event.location,
            link      = event.url,
            image     = event.image;

        var $similarEventTitle = $('.similar-event__title'),
            $similarEventWrap  = $('.similar-event__wrap');

        var temp = $('<a/>', {"href": link})
        .append($('<div/>', {"class": "event-list__image", "role": "presentaion"}))
        .append($('<div/>', {"class": "event-list__info"})
            .append($('<div/>', {"class": "event-list__date"})
                .append($('<div/>', {"class": "class--void"})
                    .append($('<span/>', {text: eventdate}))
                )
            )
            .append($('<div/>', {"class": "event-list__title"})
                .append($('<div/>', {"class": "class--void"})
                    .append($('<span/>', {text: title}))
                )
            )
        )
        .append($('<div/>', {"class": "event-list__details"})
            .append($('<div/>', {"class": "event-list__time", text: eventtime }))
            .append($('<div/>', {"class": "event-list__location", text: location }))
        )

        $similarEventWrap.append(temp);
        $('.similar-event__wrap .event-list__image').css('background-image', 'url('+image+')');
        $similarEventWrap.removeClass('visuallyhidden');
        $similarEventTitle.removeClass('visuallyhidden');
    }

    function navEvent(event, nav) {
        var name      = event.name,
            link      = event.url,
            eventdate = event.date;
        var navText = nav == 'prev' ? 'Previous' : 'Next';

        var dateObj = new Date(eventdate);
        var today   = new Date();
        if(dateObj < today) {
            return;
        }

        var temp =  $('<a/>', {"href": link})
        .append($('<div/>', {"class": "page-navigation__label", text: navText}))
        .append($('<div/>', {"class": "page-navigation__title", text: name}));

        if(nav == 'prev') {
            $prevContainer.append(temp).addClass("page-navigation__item-prev");
        } else if(nav == 'next') {
            $nextContainer.append(temp).addClass("page-navigation__item-next");
        }
    }
}(jQuery));
